module.exports = __webpack_public_path__ + "img/jingxuan03.07d9f3b1.png";